import React from "react";
import parse from "html-react-parser";
import "../CSS_stuff/Special_stuff_homepage.css";

/**
 * Temporary page to use in place of FeaturedBooks on the homepage.
 *
 * Usage:
 * - Drop an image into src/assets and update the import path below (or pass your own path).
 * - Edit the `meta.description` HTML string to add <em>, <strong>, <p>, <ul>, etc.
 *
 * IMPORTANT: This component uses html-react-parser to render the HTML string.
 * If the description ever comes from a CMS or user input, sanitize it (DOMPurify) before rendering.
 */

// Update this import to the actual image you want to display for the special homepage
import SpecialBanner from "../assets/KS Banner.jpg";

const meta = {
  img: SpecialBanner,
  description: `
    <strong>Knightess of the Realm: Spicy Epic Dragon Romantasy series!</strong>

    <p>
      <strong>Ten thousand years and it all comes down to one young woman. Why Choose, MMF, feisty FMC, Dragons, Fated Mates. The Illuminati meets Pern.</strong>
    </p>

    <p>
        <strong>Do you love:
        <ol>
            <li>a feisty FMC who’s deeply in love BUT is concerned that her fated mates will cramp her style...
            <li>Hot, broody MMCs with a PAST that keeps getting in the way of loving their lady – and each other...
            <li>Dragons whose deep connection with magic has them doing the unthinkable – and bringing their babies along with them!
        </ol>
    </p>

    <p>
      Not to mention that our feisty FMC – the first Knightess of the Realm in over a century – is also in charge of an <em>Illuminati-style</em> world-wide
      conspiracy… and she hasn’t told her lovers about it yet.
    </p>

    <p>
      Karana never planned to become the first knightess in a century. Or to find her fated mates. She hadn’t even particularly wanted to follow her papa as Head of House Metreedi and keep up The Family’s Goddess-given Onus to protect the peace and prosperity of the known world.
    </p>

    <p>
      And becoming one of the Realm’s first dragonkeepers in a thousand years — well, she’d sort of fantasized about that, because what little girl didn’t?
    </p>

    <p>
      Join Karana and her loves – human and dragon both – in this rich and exciting new world!
    </p>
  `,
  // Change this to your real campaign URL
  kickstarterUrl: "https://www.kickstarter.com/projects/mangala-knightess/knightess-of-the-realm-spicy-epic-dragon-romantasy-series-0?ref=5n3dxl"
};

export default function Special_stuff_homepage() {
  return (
    
    <div className="special-homepage-container">
      {meta.kickstarterUrl && (
          <div className="special-homepage-cta">
            <a
              className="kickstarter-button"
              href={meta.kickstarterUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Kickstarter (opens in a new tab)"
            >
              Visit the Kickstarter
            </a>
          </div>
        )}

      {meta.img && (
        <div className="special-homepage-banner">
          <img src={meta.img} alt="Special feature banner" loading="lazy" />
        </div>
      )}

      <div className="special-homepage-content">
        <div className="special-homepage-description" aria-live="polite">
          {meta.description ? parse(meta.description) : null}
        </div>

        {meta.kickstarterUrl && (
          <div className="special-homepage-cta">
            <a
              className="kickstarter-button"
              href={meta.kickstarterUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Kickstarter (opens in a new tab)"
            >
              Visit the Kickstarter
            </a>
          </div>
        )}
      </div>
    </div>
  );
}